import { render, staticRenderFns } from "./RegisterPenelitiKeamanan.vue?vue&type=template&id=31c793c8&scoped=true&"
import script from "./RegisterPenelitiKeamanan.vue?vue&type=script&lang=js&"
export * from "./RegisterPenelitiKeamanan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c793c8",
  null
  
)

export default component.exports